import { IconMapCar16, IconMapWalk16, ISVGIconProps } from '@cian/ui-kit-design-tokens/icons';

import { FC } from 'react';

import styles from './RemotenessIcon.css';
import { RemotenessTypes } from 'shared/types/RemotenessTypes';

type RemotenessIconProps = {
  iconType: RemotenessTypes;
  iconColor: string | null;
};

export const RemotenessIcon: FC<RemotenessIconProps> = props => {
  const { iconType, iconColor } = props;

  const Icon = ((): React.FC<ISVGIconProps> => {
    switch (iconType) {
      case 'transport':
        return IconMapCar16;
      case 'walk':
        return IconMapWalk16;
    }
  })();

  if (!Icon) {
    return null;
  }

  return (
    <div className={styles['container']} style={iconColor ? { color: iconColor } : undefined}>
      <Icon data-testid={`remoteness-icon-${iconType}`} color={iconColor ? 'current_color' : undefined} />
    </div>
  );
};
